export default {
  "content": "<path d=\"M20.64 12.205c0-.639-.057-1.252-.164-1.841H12v3.485h4.844a4.15 4.15 0 01-1.809 2.708v2.267h2.921c1.702-1.571 2.684-3.879 2.684-6.62z\" fill=\"#4285F4\"/><path d=\"M12 21c2.43 0 4.467-.802 5.956-2.176l-2.92-2.267c-.802.54-1.825.867-3.036.867-2.34 0-4.328-1.579-5.04-3.706H3.965v2.324C5.446 18.979 8.482 21 12 21z\" fill=\"#34A853\"/><path d=\"M6.96 13.71A5.393 5.393 0 016.674 12c0-.597.106-1.17.286-1.71V7.966H3.965A8.889 8.889 0 003 12a8.89 8.89 0 00.965 4.034l2.332-1.817.663-.507z\" fill=\"#FBBC05\"/><path d=\"M12 6.584c1.325 0 2.504.458 3.445 1.341l2.577-2.577C16.459 3.892 14.43 3 12 3 8.482 3 5.446 5.02 3.965 7.966L6.96 10.29c.712-2.127 2.7-3.706 5.04-3.706z\" fill=\"#EA4335\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};